import { render, staticRenderFns } from "./jsonModal.vue?vue&type=template&id=16d9ae82&"
import script from "./jsonModal.vue?vue&type=script&lang=js&"
export * from "./jsonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports